import templateUrl from './about-us-in-the-news-archive.html';
import head from 'lodash/head';
import clone from 'lodash/clone';
import size from 'lodash/size';
import findIndex from 'lodash/findIndex';

export const aboutUsInTheNewsArchiveComponent = {
	templateUrl,

	bindings: {
		slugUrl: '@'
	},

	controller: class AboutUsInTheNewsArchiveComponent {
		constructor(AboutUsInTheNewsArchiveService, $anchorScroll) {
			'ngInject';

			this.aboutUsInTheNewsArchiveService = AboutUsInTheNewsArchiveService;
			this.$anchorScroll = $anchorScroll;
		}

		$onInit() {	
			this.currentPage = 1;
			this.itemPerPage = 10;

			this.filterDetails = {
				'limit': this.itemPerPage,
				'pageId': this.currentPage
			};

			this.selectedYearId = '';
			this.yearList = [];
			this._getYearList();
		}

		onChange(pageNumber) {
			this.currentPage = pageNumber;
			this.filterDetails.limit = this.itemPerPage;
			this.filterDetails.pageId = this.currentPage;
			this._getArchiveInTheNewsFilterDetails();
		}

		onProgramYearChange(year) {
			this.selectedYearId = year;
			this.currentPage = 1;
			this.filterDetails.pageId = this.currentPage;
			this._getArchiveInTheNewsFilterDetails();
		}

		// ==============================================================PRIVATE METHODS==================================================

		_getArchiveInTheNewsFilterDetails() {
			this.aboutUsInTheNewsArchiveService.getInTheNewsFilterData({ year: this.selectedYearId, filterDetails: this.filterDetails }, this.slugUrl)
				.then((details) => {
					this.totalItems = clone(details.count);
					this.details = clone(details.details);
					this.$anchorScroll(() => $location.hash());	
				});
		}

		_getYearList() {
			this.aboutUsInTheNewsArchiveService.getYearList()
				.then(yearList => {
					this.yearList = yearList;
					this.selectedYearId = head(yearList).id || '';
					this._getArchiveInTheNewsFilterDetails();
				});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-in-the-news-archive/about-us-in-the-news-archive.component.js